import axios from "axios";

export default class S3Service {
	constructor() {
		this.axios = axios.create({
			headers: {
				"Access-Control-Allow-Origin": "*",
			},
		});
		window.S3axios = this.axios;
	}

	/**
	 * Get Method Wrapper
	 */
	get(resource, options = null) {
		return this.axios.get(resource, options);
	}

	/**
	 * Post Method Wrapper
	 */
	post(resource, data, options = null) {
		return this.axios.post(resource, data, options);
	}

	/**
	 * Put Method Wrapper
	 */
	put(resource, data, options = null) {
		return this.axios.put(resource, data, options);
	}

	/**
	 * Patch Method Wrapper
	 */
	patch(resource, data, options = null) {
		return this.axios.patch(resource, data, options);
	}

	/**
	 * Delete Method Wrapper
	 */
	delete(resource, data, options = null) {
		return this.axios.delete(resource, data, options);
	}

	/**
	 * Perform a custom Axios request.
	 *
	 * data is an object containing the following properties:
	 *  - method
	 *  - url
	 *  - data ... request payload
	 *  - auth (optional)
	 *    - username
	 *    - password
	 **/
	customRequest(data) {
		return this.axios(data);
	}
}
